import boundary from './settings-boundary-en'
import workflow from './settings-workflow-en'

/** Settings -> Planning (plan E). `title` and `subtitle` are plan A's placeholder strings, kept as they were. */
export default {
  title: 'Planning settings',
  subtitle: 'Configuration for the Planning module will appear here.',
  description: 'Plan types, coordinate system, officer groups, the map register and upload limits for Planning.',
  profiles: 'Plan types',
  profilesHint: 'Officers can choose only enabled plan types.',
  profilesRequired: 'Enable at least one plan type.',
  defaultCrs: 'Default coordinate system',
  roles: 'Officer groups',
  reviewerGroups: 'Reviewer groups',
  reviewerHint: 'Members with the admin or publisher role can create, return and retry submissions.',
  approverGroups: 'Approver groups',
  approverHint: 'Members with the admin or publisher role can also approve and delete.',
  noGroups: 'No groups exist yet. Create them in Settings → Groups.',
  unknownGroup: 'Unknown or deleted group ({{id}}). Untick it to remove it.',
  loadingGroups: 'Loading groups…',
  separation: 'Require a different approver',
  separationHint: 'The approver of a revision must not be the person who submitted it.',
  register: 'Map register server',
  registerHint: 'The PostgreSQL server that holds the staging and approved planning layers.',
  registerManaged: "Managed automatically: this tenant's planning layers live in its managed database.",
  registerNone: 'Not configured',
  registerLocked: 'Locked: submissions already exist on this server.',
  ...boundary,
  selfRegistrationSection: 'Applicant accounts',
  selfRegistration: 'Allow applicants to register themselves',
  selfRegistrationHint:
    'Consultants can ask for an applicant account on a public page. Each request waits for approval, and a seat is used only when it is approved.',
  selfRegistrationLink: 'Public registration page',
  selfRegistrationLinkHint: 'Share this link with consultants. It accepts requests once this setting is saved.',
  selfRegistrationCopy: 'Copy link',
  selfRegistrationCopied: 'Copied',
  allowApproverProvisioning: 'Let approver officers approve registrations',
  allowApproverProvisioningHint:
    'Otherwise only tenant administrators can approve applicant registrations. Officers who are only reviewers never can.',
  allowApproverProvisioningWarning:
    'Each approval uses a paid viewer seat. With this on, approver officers can spend seats without an administrator.',
  maxUpload: 'Maximum upload size (MB)',
  maxUploadHint: 'Between 1 and 200 MB.',
  maxUploadInvalid: 'Enter a whole number between 1 and 200.',
  save: 'Save',
  saving: 'Saving…',
  saved: 'Settings saved.',
  workflow,
} as const
